import { render, staticRenderFns } from "./VehicleListDataTable.vue?vue&type=template&id=f1b1d83c&"
import script from "./VehicleListDataTable.vue?vue&type=script&lang=js&"
export * from "./VehicleListDataTable.vue?vue&type=script&lang=js&"
import style0 from "./VehicleListDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports